var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import sanitizeHtml from 'sanitize-html';
import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectDatasetRulesDomain = function (state) {
    return state.datasetRules || getInitialState();
};
export var selectDatasetRules = createSelector(selectDatasetRulesDomain, function (datasetRulesDomain) { return datasetRulesDomain.datasetRules; });
export var selectDatasetRulesLoading = createSelector(selectDatasetRulesDomain, function (datasetRulesDomain) { return datasetRulesDomain.loading; });
export var selectDatasetRulesDatasetId = createSelector(selectDatasetRulesDomain, function (datasetRulesDomain) { return datasetRulesDomain.datasetId; });
export var selectDatasetIsNewRuleId = createSelector(selectDatasetRulesDomain, function (datasetRulesDomain) { return datasetRulesDomain.isNewDatasetId; });
export var selectDatasetNewRuleId = createSelector(selectDatasetRulesDomain, function (datasetRulesDomain) { return datasetRulesDomain.datasetNewRuleId; });
export var selectDatasetRuleGroups = createSelector(selectDatasetRulesDomain, function (domain) { return domain.groups; });
export var selectDatasetColumns = createSelector(selectDatasetRulesDomain, function (domain) { return domain.columns; });
export var selectDatasetName = createSelector(selectDatasetRulesDomain, function (domain) { return domain.datasetName; });
export var selectDatasetType = createSelector(selectDatasetRulesDomain, function (domain) { return domain.datasetType; });
export var datasetSelector = createSelector(selectDatasetRulesDomain, function (appState) { return (__assign(__assign({}, appState), { rows: ((appState === null || appState === void 0 ? void 0 : appState.rows) || []).map(function (row) {
        var _a, _b;
        var record = {
            id: row.id,
            created_at: {
                type: 'string',
                value: row.created_at,
            },
            updated_at: {
                type: 'string',
                value: row.updated_at,
            },
        };
        for (var _i = 0, _c = appState.columns.fields; _i < _c.length; _i++) {
            var field = _c[_i];
            record[field.name] = {
                type: field.type,
                value: field.type === 'richtext' && row[field.name]
                    ? sanitizeHtml(row[field.name], { allowedTags: [] })
                    : row[field.name],
                name: field.name,
            };
        }
        if (moment().isBetween(moment(((_a = record._publish_at) === null || _a === void 0 ? void 0 : _a.value) || moment().startOf('day')), moment(((_b = record._unpublish_at) === null || _b === void 0 ? void 0 : _b.value) || moment().add(1, 'day')))) {
            record.published = {
                type: 'boolean',
                value: true,
                name: 'published',
            };
        }
        else {
            record.published = {
                type: 'boolean',
                value: false,
                name: 'published',
            };
        }
        return record;
    }), columns: __assign(__assign({}, appState.columns), { fields: (appState.columns.fields || []).filter(function (item) { return item.name !== '_publish_at' && item.name !== '_unpublish_at'; }) }) })); });
export var selectGroupDropdownOptions = createSelector(selectDatasetRulesDomain, function (_a) {
    var groups = _a.groups;
    return groups === null || groups === void 0 ? void 0 : groups.map(function (group) { return ({
        id: group.id,
        value: group.id,
        label: group.label,
    }); });
});
